import React, { Component, } from 'react'

import {CCButton, CCIcon} from './../../cc-imports'

import PropTypes from 'prop-types'
import './../../styles/css/components/CCAck/cc-ack.css'

class CCAck extends Component {

    static propTypes = {
        title : PropTypes.string,
        detail : PropTypes.string,
        type : PropTypes.string,
        onAck : PropTypes.func,
        buttonText: PropTypes.string
    }

    static defaultProps = {
        title : undefined,
        detail : undefined,
        type : undefined,
        buttonText : 'OK',
        onAck:()=>{}
    }

    constructor(props) {
        super(props)
        this.state = {}

    }


    render() {
        return (
            <div className="flex-container ack-container"  style={{ ...this.props.style}}>
                <div>
                    <div className="flex-container ack-container2">
                        <h3 className="ack-font">{this.props.title}</h3>
                    </div>
                    <div className="flex-container ack-container3" style={{}}>
                        <h3 className="ack-font" >{this.props.detail}</h3>
                    </div>
                    <div className="flex-container ack-container4">
                        <CCIcon type={'success'} className="ack-success"/>
                    </div>
                    <div className="ack-container5">
                        <CCButton title={this.props.buttonText} onPress={this.props.onAck}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default CCAck


// WEBPACK FOOTER //
// ./src/app/components/CCAck/CCAck.js